var map = {
	"./10-C.png": 1733,
	"./10-D.png": 7690,
	"./10-H.png": 3195,
	"./10-S.png": 5930,
	"./2-C.png": 7962,
	"./2-D.png": 4388,
	"./2-H.png": 5102,
	"./2-S.png": 4907,
	"./3-C.png": 5514,
	"./3-D.png": 7492,
	"./3-H.png": 9350,
	"./3-S.png": 7226,
	"./4-C.png": 4334,
	"./4-D.png": 185,
	"./4-H.png": 2908,
	"./4-S.png": 8838,
	"./5-C.png": 1109,
	"./5-D.png": 4784,
	"./5-H.png": 769,
	"./5-S.png": 4867,
	"./6-C.png": 3783,
	"./6-D.png": 9358,
	"./6-H.png": 6177,
	"./6-S.png": 5120,
	"./7-C.png": 4302,
	"./7-D.png": 4425,
	"./7-H.png": 6619,
	"./7-S.png": 2280,
	"./8-C.png": 1058,
	"./8-D.png": 9322,
	"./8-H.png": 9657,
	"./8-S.png": 7348,
	"./9-C.png": 7990,
	"./9-D.png": 4804,
	"./9-H.png": 1401,
	"./9-S.png": 8263,
	"./A-C.png": 4572,
	"./A-D.png": 1976,
	"./A-H.png": 7451,
	"./A-S.png": 2560,
	"./J-C.png": 8923,
	"./J-D.png": 1450,
	"./J-H.png": 5439,
	"./J-S.png": 3317,
	"./K-C.png": 3683,
	"./K-D.png": 4269,
	"./K-H.png": 2018,
	"./K-S.png": 3062,
	"./Q-C.png": 6117,
	"./Q-D.png": 5886,
	"./Q-H.png": 9961,
	"./Q-S.png": 3281,
	"./blackjack-dollar-sign.png": 1152,
	"./blackjack-number-0.png": 1717,
	"./blackjack-number-1.png": 9926,
	"./blackjack-number-2.png": 2235,
	"./blackjack-number-3.png": 5767,
	"./blackjack-number-4.png": 3578,
	"./blackjack-number-5.png": 250,
	"./blackjack-number-6.png": 3895,
	"./blackjack-number-7.png": 2889,
	"./blackjack-number-8.png": 9744,
	"./blackjack-number-9.png": 1997,
	"./blackjack-push.png": 390,
	"./blackjack-title.png": 3024,
	"./blackjack-you-lose.png": 6215,
	"./blackjack-you-win.png": 2226,
	"./card-back.png": 9113,
	"./deal-button-hover.png": 9063,
	"./deal-button.png": 8724,
	"./double-button.png": 4402,
	"./hit-button.png": 3006,
	"./money-chip-1.png": 2452,
	"./money-chip-10.png": 3146,
	"./money-chip-100.png": 4109,
	"./money-chip-25.png": 4309,
	"./money-chip-5.png": 2624,
	"./money-chip-draft.png": 3206,
	"./place-your-bet.png": 920,
	"./stand-button.png": 8324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5823;